import React from "react";
import styled from "styled-components";

const Placeholder = styled.span`
  font-family: "BLOKK";
  font-weight: normal;
  letter-spacing: -0.2px;

  opacity: 0.6;
`;

const addLenToTxt = (l, t) =>
  l <= 0 ? t || "" : addLenToTxt(l - 1, (t || "") + "o");

const get = (translations, key, length) => {
  return translations && key && translations[key] ? (
    translations[key]
  ) : (
    <Placeholder>
      {length
        ? length === -1
          ? key
          : addLenToTxt(length, "")
        : addLenToTxt(key.length, " ") || "placeholder"}
    </Placeholder>
  );
};

const getAsProp = (translations, key, length) => {
  return translations && key && translations[key]
    ? translations[key]
    : length
      ? length === -1
        ? key
        : addLenToTxt(length, "")
      : addLenToTxt(key.length, " ") || "placeholder";
};

const text = { get, getAsProp };

export default text;



// WEBPACK FOOTER //
// ./src/helper/text.js